import { Stack } from "@mui/material";

import { useTranslation } from "react-i18next";

import { ZonePermissionEnum } from "authorization/types";
import { useAuthenticatedUser } from "hooks/useAuthenticatedUser";
import { IZone } from "interfaces/zone.interface";

import { NightReportSettings } from "./components/NightReportSettings";
import { DeleteZoneDialog } from "./dialogs/DeleteZoneDialog";
import { UpdateZoneForm } from "./forms/UpdateZoneForm";
import { NotificationScreen } from "./modules/notification/NotificationScreen";

import { PageHeader } from "../components/PageHeader";

type ZoneSettingsPageProps = {
  zone: IZone;
  zones: IZone[];
};

export function ZoneEditPage({ zone, zones }: ZoneSettingsPageProps) {
  const { t } = useTranslation();

  const { permissions } = useAuthenticatedUser();

  const disableZoneUpdate = !permissions.includes(
    ZonePermissionEnum["zone.update"],
  );

  return (
    <Stack sx={{ gap: 2 }}>
      <PageHeader title={`${t("Zone Settings")} - ${zone.name}`} />
      <UpdateZoneForm
        key={zone.id + "update"}
        zone={zone}
        zones={zones}
        disabled={disableZoneUpdate}
      />
      <NightReportSettings
        key={zone.id + "settings"}
        zone={zone}
        zones={zones}
      />
      <NotificationScreen zone={zone} zones={zones} />
      <Stack direction={"row-reverse"}>
        <DeleteZoneDialog zone={zone} />
      </Stack>
    </Stack>
  );
}
